import { route } from './route';

/**
 * Dispatch cart count to React Navbar/MobileToolbar and sessionStorage.
 * Use this when you already have the count (e.g. from modifyItem response).
 */
export function dispatchCartCount(count: number): void {
  try { sessionStorage.setItem('cart_count', String(count)); } catch {}
  window.dispatchEvent(new CustomEvent('cart-updated', { detail: { count } }));
}

/**
 * Fetches the current cart count and dispatches a 'cart-updated' event
 * so the React Navbar and MobileToolbar can update their badges.
 */
export async function updateCartBadge(): Promise<void> {
  try {
    const response = await fetch(route('api.cart.summary'), {
      credentials: 'include',
      cache: 'no-store',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });

    if (!response.ok) return;

    const data = await response.json();
    const count = data.content ? data.content.length : 0;
    dispatchCartCount(count);
  } catch {
    // Silently fail
  }
}
